import React, { useContext, useReducer, createContext, useEffect } from 'react'
import { ApplicationContext } from '../../contexts/ApplicationContext'
import reducer, { propsToState } from './reducer'
import { actionCreators } from './actions'

export const FnaContext = createContext(null)

export const FnaProvider = (props) => {
  const { trackingDetails } = useContext(ApplicationContext)
  const [internalState, dispatch] = useReducer(
    reducer,
    propsToState(props))
  const state = { ...internalState, ...props }
  const actionsWithDispatch = actionCreators(dispatch, state)

  return (
    <FnaContext.Provider value={{ state, trackingDetails, actions: actionsWithDispatch }}>
      {props.children}
    </FnaContext.Provider>
  )
}
